// extracted by mini-css-extract-plugin
export default {"info":"evF9c","valueLow":"XvL55","valueMedium":"Ius8F","valueHigh":"VkuTs","text":"sSZE8"};